import { atom } from "recoil";

export const isEmptyPayementAtom = atom({
  key: "isEmptyPayementAtom",
  default: false,
});
